import React, { useState } from "react";
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import "./userProfile.scss";
import Orders from "./Orders";
import axios from "axios";
import Loading from "../../components/loading/Loading";

const UserProfile = () => {
  const { buyer, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    try {
      setLoading(true);
      await axios.get("/buyer-logout");
      localStorage.removeItem("buyer");
      dispatch({ type: "LOGOUT" });
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="__fw">
      <div className="__mw">
        <div className="profile_wrp">
          <div className="profile_data">
            <div className="pro_lft">
              <div className="pro_img_wrp">
                <h1>{buyer.fullName?.substring(0, 2).toUpperCase()}</h1>
              </div>
              <div className="btn" onClick={handleLogout}>
                Logout
              </div>
            </div>
            <div className="pro_rgt">
              <div>
                <p>
                  <em>Full Name: </em>
                  {buyer.fullName}{" "}
                </p>
                <p>
                  <em>Phone : </em>
                  {buyer.phone}{" "}
                </p>
                <p>
                  <em>Email : </em>
                  {buyer.email}{" "}
                </p>
              </div>
              <div>
                <p>
                  <em>Address : </em>
                  {buyer.homeName}, <br /> {buyer.address},{buyer.city},<br />
                  {buyer.landmark}
                </p>
              </div>
            </div>
          </div>
          <div className="oder_wrp">
            <Orders />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
